module.exports = __webpack_public_path__ + "img/ME.2cabaedb.png";